import {createContext} from 'react';

const DialogContext = createContext({onClose: () => {}});
DialogContext.displayName = 'Dialog';

export default DialogContext;
